// src/components/Dashboard/AdminHome.js
import React from 'react';

const AdminHome = () => {
  return (
    <div className="admin-home">
      <h2>Welcome to Admin Dashboard</h2>
      <div className="welcome-content">
        <p>Use the tabs above to manage:</p>
        <ul>
          <li>Partner Applications</li>
          <li>Member Applications</li>
          <li>Approved Applications</li>
          <li>User Roles</li>
        </ul>
      </div>
    </div>
  );
};

export default AdminHome;